import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'styled-components';
import { NEUTRAL_500, NEUTRAL_1600 } from 'visitor-ui-component-library/constants/WidgetColors';
import FriendlySenderName from '../headers/FriendlySenderName';
// @ts-ignore untyped JS module
import { getSenderFromMessageSenders } from '../common-message/operators/getSenderFromMessageSenders';
import { SPOTLIGHT_STANDALONE_PADDING_PX } from '../primary-message/components/messageDimensions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "ResponderJoinedMessage__Wrapper"
})(["display:flex;align-items:center;gap:8px;padding:16px ", "px;"], SPOTLIGHT_STANDALONE_PADDING_PX);
const Divider = styled.div.withConfig({
  displayName: "ResponderJoinedMessage__Divider"
})(["flex:1;border-top:solid 1px ", ";"], NEUTRAL_500);
const Label = styled.span.withConfig({
  displayName: "ResponderJoinedMessage__Label"
})(["font-size:14px;line-height:24px;font-weight:300;color:", ";text-align:center;"], NEUTRAL_1600);
const ResponderJoinedMessage = ({
  message,
  senders
}) => {
  const sender = getSenderFromMessageSenders(message, senders);
  return /*#__PURE__*/_jsxs(Wrapper, {
    "data-test-id": "responder-joined-message",
    children: [/*#__PURE__*/_jsx(Divider, {
      "data-test-id": "responder-joined-divider"
    }), /*#__PURE__*/_jsx(Label, {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "conversations-visitor-message-history.responderJoined.joinedConversation",
        options: {
          agentName: /*#__PURE__*/_jsx(FriendlySenderName, {
            sender: sender
          })
        }
      })
    }), /*#__PURE__*/_jsx(Divider, {
      "data-test-id": "responder-joined-divider"
    })]
  });
};
ResponderJoinedMessage.displayName = 'ResponderJoinedMessage';
export default ResponderJoinedMessage;